import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const sections = [
  {
    title: 'Toplanan Məlumatlar',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
      </svg>
    ),
    body: 'Saytımızda qeydiyyat, bilet sifarişi və digər fəaliyyətlər zamanı ad, soyad, email ünvanı, telefon nömrəsi və ödəniş məlumatları toplanıla bilər.',
  },
  {
    title: 'Məlumatların İstifadəsi',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 010 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 010-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    body: 'Toplanmış məlumatlar xidmətlərin göstərilməsi, sifarişlərin icrası, istifadəçi dəstəyi və xidmət təkmilləşdirilməsi üçün istifadə olunur.',
  },
  {
    title: 'Məlumatların Qorunması',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    body: 'Şəxsi məlumatlarınız müasir təhlükəsizlik texnologiyaları və 256-bit SSL şifrələmə ilə qorunur. Sizin məlumatlarınızın icazəsiz istifadəsinin qarşısını almaq üçün bütün lazımi tədbirlər görülür.',
  },
  {
    title: 'Üçüncü Tərəflərlə Paylaşım',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
      </svg>
    ),
    body: 'Şəxsi məlumatlarınız yalnız hüquqi öhdəliklər çərçivəsində və ya sizin açıq razılığınızla üçüncü tərəflərlə paylaşılır. Marketinq məqsədilə üçüncü tərəflərə heç bir məlumat ötürülmür.',
  },
];

const PrivacyPolicyPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-surface-950 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh opacity-15" />
        <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-accent-600/10 rounded-full blur-[120px]" />

        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 pt-32 pb-20 text-center">
          <div className="flex items-center justify-center gap-2 text-sm mb-6">
            <Link to="/" className="text-surface-500 hover:text-white transition">Ana Səhifə</Link>
            <svg className="w-3.5 h-3.5 text-surface-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
            <span className="text-white/70">Məxfilik Siyasəti</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6">
            Məxfilik Siyasəti
          </h1>
          <p className="text-lg text-surface-400 max-w-2xl mx-auto leading-relaxed font-light">
            Tixy.az istifadəçilərinin şəxsi məlumatlarının təhlükəsizliyini qorumağa sadiqdir.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          {/* Intro */}
          <p className="text-lg text-surface-600 leading-relaxed mb-14 max-w-3xl">
            Bu Məxfilik Siyasəti sizin hansı məlumatların toplandığını, necə istifadə olunduğunu və qorunduğunu izah edir.
            Platformamızdan istifadə edərək bu siyasətin şərtlərinə razılıq vermiş olursunuz.
          </p>

          {/* Sections */}
          <div className="space-y-6">
            {sections.map((section, i) => (
              <div key={i} className="group bg-surface-50 hover:bg-white rounded-3xl p-8 border border-surface-100 hover:border-surface-200 hover:shadow-lg hover:shadow-surface-100/50 transition-all duration-300">
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-accent-50 text-accent-600 flex items-center justify-center group-hover:bg-accent-100 transition-colors duration-300">
                    {section.icon}
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-surface-900 mb-3">{section.title}</h2>
                    <p className="text-surface-600 leading-relaxed">{section.body}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact section */}
          <div className="mt-14 bg-surface-50 rounded-3xl p-8 md:p-10 border border-surface-100">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h2 className="text-xl font-bold text-surface-900 mb-2">Sualınız var?</h2>
                <p className="text-surface-500">
                  Məxfilik siyasətimizlə bağlı sual və ya təklifləriniz varsa, bizimlə əlaqə saxlayın.
                </p>
              </div>
              <a
                href="mailto:info@tixy.az"
                className="flex-shrink-0 inline-flex items-center gap-2 bg-surface-900 text-white font-semibold px-6 py-3.5 rounded-2xl hover:bg-surface-800 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                info@tixy.az
              </a>
            </div>
          </div>

          {/* Last updated */}
          <div className="mt-8 text-center text-sm text-surface-400">
            Son yenilənmə: 2025
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicyPage;
